import {
  createContext,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { getUserGeolocationService } from "../services/UserInfoService";

export const GeoContext = createContext({
  sent: false,
  sendGeo: async () => {},
});

// Se mantiene fuera del componente para deduplicar incluso si React.StrictMode
// vuelve a ejecutar el arbol durante desarrollo.
let geoRequestInFlight = null;

export function GeoProvider({ children }) {
  const [sent, setSent] = useState(
    () => sessionStorage.getItem("geoSent") === "true",
  );
  const sentRef = useRef(sent);

  const sendGeo = useCallback(async (payload) => {
    if (
      sentRef.current ||
      sessionStorage.getItem("geoSent") === "true"
    ) {
      return;
    }

    if (geoRequestInFlight) {
      return geoRequestInFlight;
    }

    const request = (async () => {
      try {
        const response = await getUserGeolocationService(payload);
        sessionStorage.setItem("geoSent", "true");
        sentRef.current = true;
        setSent(true);
        return response;
      } catch (error) {
        console.error("Error al enviar geoloc:", error);
        throw error;
      }
    })();

    geoRequestInFlight = request;

    try {
      return await request;
    } finally {
      if (geoRequestInFlight === request) {
        geoRequestInFlight = null;
      }
    }
  }, []);

  const value = useMemo(
    () => ({
      sent,
      sendGeo,
    }),
    [sendGeo, sent],
  );

  return <GeoContext.Provider value={value}>{children}</GeoContext.Provider>;
}
